export default __webpack_public_path__ + "static/text-bottom-grey-mobile-dc9bca077d888037324c4c765fa010e8.svg";